export default {
    state: {
      defaultData: {},
    },
  
    getters: {
      getVacanciesData(state) {
        return state.defaultData;
      },
    },
  
    mutations: {
      setVacanciesData(state, data) {
        const isNull = data === null;
  
        state.defaultData = {
          county: !isNull ? data.county : "",
          month: !isNull ? Number(data.month) : "",
          offer_id: !isNull ? data.offer_id : "",
          pactuation_id: !isNull ? data.pactuation_id : "",
          procedure: !isNull ? data.procedure : "",
          quant: !isNull ? Number(data.quant) : "",
          speciality: !isNull ? data.speciality : "",
          year: !isNull ? data.year : "",
        };
      },
    },
  
    actions: {
      changeVacanciesData(context, infos) {
        context.commit("setVacanciesData", infos);
      },
    },
  };
  